import nanobus from 'nanobus'
const bus = nanobus()
export default bus